import { type AuthError, AuthErrorCodes } from 'firebase/auth';

/** Maps Firebase Auth error codes to messages a user can act on. */
export function mapFirebaseAuthError(error: unknown): string {
  const code = (error as Partial<AuthError>).code;

  switch (code) {
    case AuthErrorCodes.POPUP_CLOSED_BY_USER:
      return 'Sign-in was cancelled.';
    case AuthErrorCodes.POPUP_BLOCKED:
      return 'Your browser blocked the sign-in popup. Allow popups and try again.';
    case AuthErrorCodes.NEED_CONFIRMATION:
      return 'An account already exists with a different sign-in method.';
    case AuthErrorCodes.NETWORK_REQUEST_FAILED:
      return 'Network error. Please check your connection.';
    default:
      return 'Something went wrong. Please try again.';
  }
}
